export const CHART_NO_DATA_TEXT = 'There’s no data for this date range'

export const enrolledColumns = [{
  label: 'EMAIL',
  value: 'email'
}, {
  label: 'EMAIL NAME',
  value: 'email_name',
  width: '50%'
}, {
  label: 'UNENROLLED',
  value: 'unenrolled'
}]

export const clickColumns = [{
  label: 'EMAIL',
  value: 'email'
}, {
  label: 'EMAIL SUBJECT',
  value: 'email_name',
  width: '50%'
}, {
  label: 'SENT',
  value: 'sends'
}, {
  label: 'DELIVERED',
  value: 'deliveries'
},{
  label: 'OPENS',
  value: 'opens'
}, {
  label: 'CLICKS',
  value: 'clicks'
}]

export const signatureClickColumns = [
  {
    label: 'TEAMMATE',
    value: 'teammate',
  },
  {
    label: 'VIEWS',
    value: 'views',
  },
  {
    label: 'CLICKS',
    value: 'clicks',
  },
  {
    label: 'CONVERSATIONS',
    value: 'conversations',
  },
]

export const clickColumnsOutboundSequence = [{
  label: 'EMAIL',
  value: 'email'
}, {
  label: 'EMAIL SUBJECT',
  value: 'email_name',
  width: '50%'
}, {
  label: 'SENT',
  value: 'sends'
}, {
  label: 'OPENS',
  value: 'opens'
}, {
  label: 'CLICKS',
  value: 'clicks'
}]

export const lossColumns = [{
  label: 'EMAIL',
  value: 'email'
}, {
  label: 'EMAIL SUBJECT',
  value: 'email_name',
  width: '50%'
}, {
  label: 'BOUNCES',
  value: 'bounced'
}, {
  label: 'UNSUBSCRIBES',
  value: 'unsubscribed'
}]

export const signatureConversationColumns = [
  {
    label: 'TEAMMATE',
    value: 'teammate',
  },
  {
    label: 'CHATS',
    value: 'chats'
  }, {
    label: 'MEETINGS',
    value: 'meetings'
  }
]

export const conversationColumns = [{
  label: 'EMAIL',
  value: 'email'
}, {
  label: 'EMAIL SUBJECT',
  value: 'email_name'
}, {
  label: 'REPLIES',
  value: 'replies'
}, {
  label: 'CONVERSATIONS',
  value: 'conversations'
}, {
  label: 'MEETINGS',
  value: 'meetings'
}]

export const campaignConversationColumns = [{
  label: 'EMAIL',
  value: 'email'
}, {
  label: 'EMAIL SUBJECT',
  value: 'email_name'
}, {
  label: 'REPLIES',
  value: 'replies'
}, {
  label: 'CONVERSATIONS',
  value: 'conversations'
}]

export const dollarColumns = [{
  label: 'EMAIL',
  value: 'email'
}, {
  label: 'EMAIL SUBJECT',
  value: 'email_name'
}, {
  label: 'Opportunities',
  value: 'opportunities'
}, {
  label: 'Pipeline',
  value: 'pipeline'
}, {
  label: 'Closed Won',
  value: 'closed_won'
}]

export const peopleColumns = [{
  label: 'Name',
  value: 'name',
  width: '350px'
}, {
 label: 'Company Name',
 value: 'companyName',
 width: '200px'
}, {
 label: 'Status',
 value: 'status',
 width: '175px'
}, {
 label: 'Enrolled',
 value: 'enrolledAt',
 width: '175px'
}, {
 label: 'Opened',
 value: 'opened',
 width: '150px'
}, {
 label: 'Clicked',
 value: 'clicked',
 width: '150px'
}, {
  label: 'Email Reply',
  value: 'emailReply',
  width: '150px'
}, {
 label: 'Website Chat',
 value: 'influencedChat',
 width: '150px'
}, {
 label: 'Booked Meeting',
 value: 'influencedBookedMeeting',
 width: '150px'
}, {
  label: 'Booked With',
  value: 'influencedBookedMeetingAgentId',
  width: '350px'
}, {
  label: 'Last Send From',
  value: 'sentFrom',
  width: '200px'
}, {
 label: 'Last Sent',
 value: 'lastSendAt',
 width: '200px'
}, {
 label: 'Next Send',
 value: 'nextSendAt',
 width: '200px'
}]

export const filterableMetrics = {
  'All Activity': null,
  Opened: 'OPENED',
  Clicked: 'CLICKED',
  Replied: 'REPLIED',
  'Started A Chat': 'CONVERSATION_INFLUENCED',
  'Booked A Meeting': 'MEETING_INFLUENCED',
}
